import React from 'react';

/** Shared helpers for global search palette + results UI */

export function initials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);
  if (parts.length === 0) return '?';
  return parts.map((w) => w[0]).join('').toUpperCase();
}

export function objectTone(objectName) {
  const n = String(objectName || '').toLowerCase();
  if (n === 'lead') return 'lead';
  if (n === 'account') return 'account';
  if (n === 'contact') return 'contact';
  if (n === 'opportunity') return 'opportunity';
  const tones = ['lead', 'account', 'contact', 'opportunity'];
  let h = 0;
  for (let i = 0; i < n.length; i += 1) h = (h + n.charCodeAt(i)) % tones.length;
  return tones[h] || 'muted';
}

export function highlightText(text, query) {
  const value = text == null ? '' : String(text);
  const needle = String(query || '').trim();
  if (!needle) return value;
  const idx = value.toLowerCase().indexOf(needle.toLowerCase());
  if (idx < 0) return value;
  return (
    <>
      {value.slice(0, idx)}
      <mark>{value.slice(idx, idx + needle.length)}</mark>
      {value.slice(idx + needle.length)}
    </>
  );
}
